import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import Link from '@atlaskit/link';
import Workspace from './Workspace';
import { Text } from '@atlaskit/primitives';
import { useUserUnrestrictedAccessSummary } from './accessSummary/getUserUnrestrictedAccessSummary';

const initialWorkspaceLimit = 3;
const expandedWorkspaceLimit = 10;

export default function WorkspacePanel() {
  const accessSummary = useUserUnrestrictedAccessSummary();
  const [limit, setLimit] = useState(initialWorkspaceLimit);
  const [expanded, setExpanded] = useState(false);
  const numberLeft = (accessSummary?.totalWorkspaces ?? 0) - limit;

  return (
    <>
      {(accessSummary?.topWorkspaces ?? [])
        .slice(0, limit)
        .map(({ displayName, displayBoardCount }, i) => (
          <Workspace
            key={displayName ?? i}
            name={displayName ?? ''}
            boardCount={displayBoardCount ?? 0}
          />
        ))}
      {!expanded && numberLeft > 0 && (
        <Link
          href={''}
          onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
            e.preventDefault();
            setLimit(expandedWorkspaceLimit);
            setExpanded(true);
          }}
        >
          <FormattedMessage
            id="trello.workspaces.showMoreWorkspacesAndBoards"
            defaultMessage="Show more Workspaces and boards"
            description="Show more workspaces and boards link"
          />
        </Link>
      )}
      {expanded && numberLeft > 0 && (
        <Text weight="bold">
            <FormattedMessage
            id="trello.workspaces.andAllOtherWorkspacesAndBoards"
            defaultMessage="And {numberLeft, plural,
              one {other Workspace and boards}
              other {# other Workspaces and boards}}"
            description="Show the remaining workspaces not shown in the current list"
            values={{ numberLeft }}
          />
        </Text>
      )}
    </>
  );
}
